import {
  MockMap,
} from '@ama-sdk/core';
import {
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneyElementCommons,
  combineJourneys,
  combineJourneyTravelers,
  createBoardingPassData,
  createJourney,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  testUx,
} from '../../../e2e/config/index';
import {
  frequentFlyerCardSV,
  frequentFlyerCardUX,
  noItemToPayError,
  seatmap,
} from '../../mock/data';
import {
  contactEmail,
  contactPhone,
  journeyTraveler,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.WOMAN], {}).items
};

const journeys = combineJourneys([{
  ...journeyTemplate
}]).items;

const journeyWithFF = createJourney({
  template: {
    ...journeys[0],
    acceptance: AcceptanceRepository.ACCEPTED,
    journeyElements: combineJourneyElementCommons([
      createJourneyElementCommon({
        template: {
          ...journeys[0].journeyElements[0],
          journeyElement: createJourneyElement({
            template: {
              ...journeys[0].journeyElements[0].journeyElement,
              frequentFlyerCard: frequentFlyerCardUX
            }
          })
        }
      })
    ]).items
  }
});

const CONTACTS = [contactPhone, {
  ...contactEmail,
  travelerIds: [journeyTraveler.id],
  address: 'tester@amadeus.com'
}];

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);

const etktAndFFBoardingPassResultmultipax = combineBoardingPassResults([{
  boardingPassData:
    createBoardingPassData({
      template: {
        traveler: journeys[0].travelers[0],
        frequentFlyerCards: [
          {
            companyCode: testUx.airlineCode,
            cardNumber: '9876543210'
          }
        ]
      }
    })
}, {
  boardingPassData:
    createBoardingPassData({
      template: {
        traveler: journeys[0].travelers[1],
        frequentFlyerCards: [
          {
            companyCode: testUx.airlineCode,
            cardNumber: '9876543210'
          }
        ]
      }
    })
}],
{
  journeyElementIds
}).items;

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 * FF added
 * Boarding Passes sent
 * Contact added
 */
export const ow1Journey2AdtFFBoardingPassRetrieve: MockMap = {
  addContactsToJourney: [createMockData(CONTACTS)],
  addFrequentFlyerCardToJourney: [
    createMockData(frequentFlyerCardSV),
    createMockData(frequentFlyerCardUX),
    createMockData(frequentFlyerCardSV),
    createMockData(frequentFlyerCardUX)],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(etktAndFFBoardingPassResultmultipax, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  retrieveJourney: [createMockData(journeyWithFF)],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
